function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.36 15.512C12.36 14.072 11.904 12.992 10.872 12.248C10.368 11.864 9.888 11.576 9.456 11.36C9.024 11.144 8.448 10.904 7.704 10.64V5.12C8.88 5.336 9.696 6.032 10.152 7.208L12.024 6.152C11.184 4.304 9.624 3.2 7.704 2.936V0.8H6.192V2.912C4.896 3.032 3.816 3.512 2.952 4.328C2.088 5.144 1.656 6.2 1.656 7.496C1.656 8.912 2.112 9.968 3.072 10.712C4.032 11.456 4.752 11.792 6.192 12.296V18.104C4.44 17.912 3.312 17.072 2.76 15.584L0.84 16.688C1.68 18.8 3.576 20.096 6.192 20.288V22.4H7.704V20.264C9.072 20.096 10.2 19.592 11.064 18.752C11.928 17.912 12.36 16.832 12.36 15.512ZM3.864 7.496C3.864 6.176 4.776 5.288 6.192 5.096V10.064C4.56 9.392 3.864 8.72 3.864 7.496ZM7.704 12.848C9.36 13.544 10.128 14.216 10.128 15.536C10.128 16.856 9.24 17.84 7.704 18.056V12.848Z",
  fill: "#45A709"
});

function SvgDollarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.3e5a0f77.svg";
export { ForwardRef as ReactComponent };